import { getString } from "../common/common";

export const CANCEL_TICKET_FOR_BUS_BOOKING = "CANCEL_TICKET_FOR_BUS_BOOKING";
export const YOU_ARE_GUEST = "YOU_ARE_GUEST";
export const PNR_NUMBER = "PNR_NUMBER";
export const TRANSACTION_PASSWORD = "TRANSACTION_PASSWORD";
export const MOBILE_NUMBER = "MOBILE_NUMBER";
export const SEARCH = "SEARCH";
export const PLEASE_ENTER_VALID_DETAILS = "PLEASE_ENTER_VALID_DETAILS";
export const ENT_CC = "ENT_CC";
export const CNTRY_CODE = "CNTRY_CODE";

export const translations = {
  en: {
    [CANCEL_TICKET_FOR_BUS_BOOKING]: "Cancel Ticket for Bus Booking",
    [YOU_ARE_GUEST]: "You are guest & not logged in",
    [PNR_NUMBER]: "PNR number",
    [TRANSACTION_PASSWORD]: "Transaction Password",
    [MOBILE_NUMBER]: "Mobile Number ",
    [SEARCH]: "SEARCH",

    [PLEASE_ENTER_VALID_DETAILS]: "Please Enter the valid details",
    [CNTRY_CODE]: "Country code",
  },
  kn: {
    [CANCEL_TICKET_FOR_BUS_BOOKING]: "ಬಸ್ ಬುಕ್ಕಿಂಗ್‌ಗಾಗಿ ಟಿಕೆಟ್ ರದ್ದುಗೊಳಿಸಿ",
    [YOU_ARE_GUEST]: "ನೀವು ಅತಿಥಿ ಹಾಗು ಲಾಗ್ ಇನ್ ಆಗಿಲ್ಲ",
    [PNR_NUMBER]: "PNR ಸಂಖ್ಯೆ",
    [TRANSACTION_PASSWORD]: "ವಹಿವಾಟು ಪಾಸ್ವರ್ಡ್",
    [MOBILE_NUMBER]: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ.",
    [SEARCH]: "ಹುಡುಕಿ ",
    [PLEASE_ENTER_VALID_DETAILS]: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ವಿವರಗಳನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [CNTRY_CODE]: "Country code",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
